import { createSelector } from 'reselect'
import featureScopesSelector from './feature-scope/featureScopesSelector'

const e3dShouldInitIn3DModeSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('e3dInitial3DView'),
)

export default e3dShouldInitIn3DModeSelector
